export default "__VITE_ASSET__BtJy2KlF__"